import {
    REVIEWS_DATA_FETCHED
} from '../actionsTypes'

const initialState = {
    productId : 0,
    pageIndex : 2,
    reviews : {items : []},
    changeFromClient : false
};

const ReviewsReducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case REVIEWS_DATA_FETCHED:
            return {
                ...state,
                pageIndex : state.pageIndex + 1,
                reviews : {
                    reviewListStatistics : action.payload.reviewListStatistics,
                    items : [...action.payload.productReviewsListItems, ...action.payload.items]
                },
                changeFromClient : action.payload.changeFromClient
            }
        default:
            return state;
    }

};

export default ReviewsReducer;